import { render, staticRenderFns } from "./LocationCard.vue?vue&type=template&id=d98de2d6"
import script from "./LocationCard.vue?vue&type=script&lang=js"
export * from "./LocationCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports